export default __webpack_public_path__ + "static/media/page_info.1c447dbd.svg";